import { useState, CSSProperties } from "react";
import ClipLoader from "react-spinners/ClipLoader";
import { useSelector } from "react-redux";

const override: CSSProperties = {
    display: 'flex',
    justifyContent: "center",
    alignItems: "center",
    alignSelf: "flex-end",
    borderWidth: "4px",
};

function Spinner({color= "", speed, size}: {color?: string, speed?: number, size?: number}) {
  const { userCompany } = useSelector((state: any) => state.auth);
  return (
    <div className="sweet-loading">
      <ClipLoader
        color={color || userCompany?.main_color}
        loading={true}
        cssOverride={override}
        size={size || 45}
        aria-label="Loading Spinner"
        data-testid="loader"
        speedMultiplier={speed || 1}
      />
    </div>
  );
}

export default Spinner;